<template>
  <a
    v-if="pdfUrl"
    :href="`#`"
    :title="title"
    class="d-inline-block px-50 text-dark"
    @click.prevent="downloadPdf"
  >
    <slot>
      <feather-icon :icon="icon" />
    </slot>
  </a>
</template>

<script>
import axios from 'axios'
import { mapMutations } from 'vuex'

export default {
  name: 'PrivatePdfDownload',
  props: {
    pdfUrl: {
      type: String,
      required: true,
    },
    fileName: {
      type: String,
      default: 'documento.pdf',
    },
    icon: {
      type: String,
      default: 'DownloadIcon',
    },
    title: {
      type: String,
      default: 'Descargar PDF',
    },
  },
  methods: {
    ...mapMutations({
      setLoading: 'app/loading',
      setNotifications: 'notifications',
      setShowNotifications: 'setShowNotifications',
    }),
    async downloadPdf() {
      this.setLoading(true)
      try {
        const token = JSON.parse(localStorage.getItem('token'))
        const response = await axios.get(this.pdfUrl, {
          responseType: 'blob',
          headers: {
            Authorization: `${token.token_type} ${token.token}`,
          },
        })

        // Normalizar el nombre del archivo
        const normalizedFileName = this.fileName.replace(/\s+/g, '_')

        // Crear un blob y descargar el archivo
        const url = URL.createObjectURL(response.data)
        const link = document.createElement('a')
        link.href = url
        link.download = normalizedFileName
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(url)
      } catch (error) {
        console.error('Error al descargar el archivo:', error)
        this.setNotifications({ title: 'Error al descargar el archivo.', variant: 'danger' })
        this.setShowNotifications(true)
      } finally {
        this.setLoading(false)
      }
    },
  },
}
</script>
